<div>
    <div class="font-13">2018 - {{currentyear}} © <b>ZERO BrandCard™</b> - Connect Possibilities</div>
    <div class="to-top" style="display: block;"><i class="fa fa-angle-double-up"></i></div>
</div>
